import { forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useRef, useState } from 'react'
import AppBreadcrumb from './AppBreadCrumb'
import { LayoutContext } from './context/layoutcontext'
import type { AppTopbarRef } from '../../types/types'
import { CommonContext } from '../common/context/commonContext'
import { WhoAmI } from '../../types/common'
import LanguagePopover from '../../component/layout/language-popover'

const AppTopbar = forwardRef<AppTopbarRef>((props, ref) => {
    const { $http } = useContext(CommonContext)
    const { onMenuToggle, showProfileSidebar } = useContext(LayoutContext)
    const [user, setUser] = useState<WhoAmI>()

    const menubuttonRef = useRef(null)
    const whoAmI = useCallback(async () => {
        const data = await $http().get('/user/whoami')
        setUser(data)
    }, [$http])

    useEffect(() => {
        whoAmI()
    }, [whoAmI])

    // const onConfigButtonClick = () => {
    //     showConfigSidebar()
    // }

    useImperativeHandle(ref, () => ({
        menubutton: menubuttonRef.current,
    }))

    return (
        <div className="layout-topbar">
            <div className="topbar-start">
                <button ref={menubuttonRef} type="button" className="topbar-menubutton p-link p-trigger" onClick={onMenuToggle}>
                    <i className="pi pi-bars"></i>
                </button>

                <AppBreadcrumb className="topbar-breadcrumb"></AppBreadcrumb>
            </div>

            <div className="topbar-end">
                <ul className="topbar-menu">
                    <li className="topbar-search">
                        <span className="p-input-icon-left">
                            {/*<i className="pi pi-search"></i>*/}
                            {/*<InputText type="text" placeholder="Search" className="w-12rem sm:w-full" />*/}
                        </span>
                    </li>
                    <li className="ml-3">
                        {/*<Button*/}
                        {/*    type="button"*/}
                        {/*    icon="pi pi-cog"*/}
                        {/*    text*/}
                        {/*    rounded*/}
                        {/*    className="p-button-text p-button-secondary flex-shrink-0"*/}
                        {/*    onClick={onConfigButtonClick}*/}
                        {/*></Button>*/}
                    </li>
                    {/*className="topbar-profile"*/}
                    <li>
                        <button type="button" className="p-link" onClick={showProfileSidebar}>
                            <span className="font-bold text-lg" style={{ color: '#0A1F48' }}>
                                {user && `${user.userNm} ${user.authGroupNm}`}
                            </span>
                        </button>
                        <LanguagePopover />
                    </li>
                </ul>
            </div>
        </div>
    )
})

AppTopbar.displayName = 'AppTopbar'

export default AppTopbar
